(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["verrite-artists-directory"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('verrite-artists-directory')) {
    customElements.define(
      'verrite-artists-directory',
      class extends HTMLElement {
        connectedCallback() {
          if (this.dataset.bound === 'true') return;
          this.dataset.bound = 'true';

          this.addEventListener('click', (event) => {
            const button = event.target.closest('[data-artist-filter]');
            if (!button || button.disabled) return;

            const letter = button.dataset.artistFilter;
            this.querySelectorAll('[data-artist-filter]').forEach((filter) => {
              filter.setAttribute('aria-pressed', String(filter === button));
            });
            this.querySelectorAll('[data-artist-card]').forEach((card) => {
              card.hidden = card.dataset.artistLetter !== letter;
            });
            this.dataset.activeLetter = letter;
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
